export default __webpack_public_path__ + "static/media/ht.6b88c7d2.svg";